export default __webpack_public_path__ + "static/media/sass.1d3de193.png";